import React from "react";
import styled from "styled-components";
import { Section, Panel, Eyebrow, H2, Lead } from "../components/ui";
import { DownloadLink } from "../components/StoreButtons";
import ChatDemo from "../components/ChatDemo";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 4rem;
  align-items: center;

  @media screen and (max-width: 64em) {
    gap: 2.5rem;
  }

  @media screen and (max-width: 48em) {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 48em) {
    align-items: center;
    text-align: center;
  }
`;

const Points = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 1.75rem 0 2rem;
  font-family: var(--fontR);
  font-size: 1rem;
  color: var(--text-inv);

  li {
    display: flex;
    align-items: baseline;
    gap: 0.625rem;
    text-align: left;
  }

  li::before {
    content: "✓";
    color: var(--violet);
    font-weight: 600;
  }
`;

const Visual = styled.div`
  display: flex;
  justify-content: center;
  background: radial-gradient(closest-side, rgba(124, 92, 255, 0.22), transparent 72%);
`;

const Disclaimer = styled.p`
  margin-top: 1.5rem;
  font-family: var(--fontR);
  font-size: 0.75rem;
  line-height: 1.5;
  color: #8a8a90;
  max-width: 30rem;
`;

// The one dark block of the page: the AI is the signature feature
const Copilot = () => (
  <Section id="copilote">
    <Panel $dark data-reveal>
      <Grid>
        <Text>
          <Eyebrow $color="#a892ff">Ton copilote</Eyebrow>
          <H2>Parle à ton argent.</H2>
          <Lead $dark>
            Pas un chatbot qui te renvoie vers un article de blog. Une IA qui voit tes comptes, tes projets et ta
            situation, et qui te répond avec tes chiffres à toi.
          </Lead>
          <Points>
            <li>Elle part de tes chiffres, pas de généralités</li>
            <li>Elle explique son raisonnement</li>
            <li>Elle ne te vend aucun produit</li>
          </Points>
          <DownloadLink tone="dark" position="copilote">
            Poser ma première question
          </DownloadLink>
          <Disclaimer>
            Exemples de conversations. Nea fournit de l'information, pas du conseil en investissement personnalisé.
            Vérifie toujours avant de décider.
          </Disclaimer>
        </Text>

        <Visual>
          <ChatDemo />
        </Visual>
      </Grid>
    </Panel>
  </Section>
);

export default Copilot;
